import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-recent-events',
  templateUrl: './recent-events.component.html',
  styleUrls: ['./recent-events.component.scss']
})
export class RecentEventsComponent implements OnInit {
  @Input() config: any;
  @Input()
  actionTemplate: TemplateRef<any>;
  displayedColumns: string[] = [];
  _dataSource: any[];
  get dataSource(): any[] {
      return this._dataSource;
  }
  @Input() set dataSource(value: any[]) {
      this._dataSource = value;
  }

  @Input() noResultsMessage = "";

  @ContentChild('cellTemplate') cellTemplate: TemplateRef<any>;


  constructor() {

  }

  initDisplayedCols(){
    this.displayedColumns =  this.config.cols.map(item=>item.key)
  }

  ngOnInit(): void {
    this.initDisplayedCols();
  }
   resolve(path, obj=self, separator='.') {
    var properties = Array.isArray(path) ? path : path.split(separator)
    return properties.reduce((prev, curr) => prev?.[curr], obj)
  }
}
